import React from 'react';
import ErrorBoundary from './ErrorBoundary';

export const AppErrorBoundary = ({ children }) => (
  <ErrorBoundary
    level="app"
    showRetry
    showHome={false}
    onRetry={() => window.location.reload()}
  >
    {children}
  </ErrorBoundary>
);

export const PageErrorBoundary = ({ children }) => (
  <ErrorBoundary level="page" showRetry showHome>
    {children}
  </ErrorBoundary>
);

export const FeatureErrorBoundary = ({ children }) => (
  <ErrorBoundary level="feature" showRetry showHome>
    {children}
  </ErrorBoundary>
);

export const ComponentErrorBoundary = ({ children, compact = true }) => (
  <ErrorBoundary level="component" showRetry showHome={false} compact={compact}>
    {children}
  </ErrorBoundary>
);

export const DataErrorBoundary = ({ children, onRetry }) => (
  <ErrorBoundary level="feature" showRetry showHome onRetry={onRetry}>
    {children}
  </ErrorBoundary>
);

export const FormErrorBoundary = ({ children }) => (
  <ErrorBoundary level="component" showRetry showHome={false} compact>
    {children}
  </ErrorBoundary>
);

export const RouteErrorBoundary = ({ children }) => (
  <ErrorBoundary level="page" showRetry={false} showHome>
    {children}
  </ErrorBoundary>
);

export const IntegrationErrorBoundary = ({ children, onRetry }) => (
  <ErrorBoundary level="feature" showRetry showHome onRetry={onRetry}>
    {children}
  </ErrorBoundary>
);

export default {
  AppErrorBoundary,
  PageErrorBoundary,
  FeatureErrorBoundary,
  ComponentErrorBoundary,
  DataErrorBoundary,
  FormErrorBoundary,
  RouteErrorBoundary,
  IntegrationErrorBoundary,
};
